import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const DART_TAG_OFFSET = { x: 30, y: -20 };

export default function Dart({ position, rotation, isDragging, isInFlight, onPointerDown }) {
  const buttonClassName = useMemo(() => {
    const classes = ['dart'];
    if (isDragging) classes.push('dragging');
    if (isInFlight) classes.push('in-flight');
    return classes.join(' ');
  }, [isDragging, isInFlight]);

  const buttonStyle = useMemo(
    () => ({
      left: `${position.x}px`,
      top: `${position.y}px`,
      transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
    }),
    [position.x, position.y, rotation]
  );

  const tagStyle = useMemo(
    () => ({
      left: `${position.x + DART_TAG_OFFSET.x}px`,
      top: `${position.y + DART_TAG_OFFSET.y}px`,
    }),
    [position.x, position.y]
  );

  const showTag = !isInFlight && !isDragging;

  return (
    <>
      <button
        type="button"
        aria-label="Throw dart"
        className={buttonClassName}
        onPointerDown={onPointerDown}
        style={buttonStyle}
      >
        <span className="dart-tip" />
        <span className="dart-body" />
        <span className="dart-flight" />
      </button>
      
      {showTag && (
        <div className="dart-tag" style={tagStyle}>
          Use me to aim
        </div>
      )}
    </>
  );
}

Dart.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  rotation: PropTypes.number.isRequired,
  isDragging: PropTypes.bool,
  isInFlight: PropTypes.bool,
  onPointerDown: PropTypes.func.isRequired,
};

